// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"fBFOg":[function(require,module,exports,__globalThis) {
document.addEventListener('DOMContentLoaded', function() {
    var mapElements = document.querySelectorAll('.acf-map');
    if (!mapElements.length) return;
    mapElements.forEach(function(mapElement) {
        var lat = parseFloat(mapElement.getAttribute('data-lat'));
        var lng = parseFloat(mapElement.getAttribute('data-lng'));
        var zoom = parseInt(mapElement.getAttribute('data-zoom')) || 16;
        // Initialize Google Map
        var map = new google.maps.Map(mapElement, {
            zoom: zoom,
            mapId: '41ab86690a62b5f3aaa1ec14',
            center: {
                lat: lat,
                lng: lng
            },
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false
        });
        // Add marker at the location
        var markerIcon = mapElement.getAttribute('data-marker-icon');
        var markerImg = mapElement.getAttribute('data-imgUrl');
        var title = mapElement.getAttribute('data-title');
        var address = mapElement.getAttribute('data-address');
        var phone = mapElement.getAttribute('data-phone');
        var marker = new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng
            },
            map: map,
            icon: markerIcon ? {
                url: markerIcon,
                scaledSize: new google.maps.Size(80, 80)
            } : undefined
        });
        var infoWindow = new google.maps.InfoWindow({
            content: "\n                <div>\n                    ".concat(markerImg ? '<div class="infowindow-img"><img src="'.concat(markerImg, '" alt="').concat(title, '"></div>') : '', '\n                    <div class="infowindow-content">\n                        ').concat(title ? "<h2>".concat(title, "</h2>") : '', "\n                        ").concat(phone ? '<div class="infowindow-detail"><div class="infowindow-detail-img"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.563" d="m21.138 17.152-4.804.931c-3.245-1.629-5.25-3.5-6.417-6.416l.899-4.819-1.699-4.515H4.741c-1.315 0-2.351 1.087-2.154 2.388.49 3.247 1.936 9.135 6.164 13.362 4.439 4.44 10.833 6.366 14.352 7.132 1.359.296 2.564-.765 2.564-2.155v-4.182z"/></svg></div><p><a href="tel:'.concat(phone, '">').concat(phone, "</a></p></div>") : '', "\n                        ").concat(address ? '<div class="infowindow-detail"><div class="infowindow-detail-img"><svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 28 28"><path stroke="currentColor" stroke-width="1.75" d="M23.333 11.667c0 5.154-9.334 14-9.334 14s-9.333-8.846-9.333-14a9.333 9.333 0 1 1 18.667 0Z"/><path fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M13.999 12.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333"/></svg></div><p>'.concat(address, "</p></div>") : '', "\n                    </div>\n                </div>\n            ")
        });
        marker.addListener('click', function() {
            map.panTo(marker.getPosition());
            infoWindow.open({
                anchor: marker,
                map: map
            });
            map.panBy(0, -(mapElement.offsetHeight * 0.25));
        });
    });
});

},{}]},["fBFOg"], "fBFOg", "parcelRequired6e5", {})

//# sourceMappingURL=content-single-location.js.map
